import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";

import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Tooltip from "@material-ui/core/Tooltip";
import {FormattedDate, FormattedNumber} from "react-intl";
import DeleteButton from "../../components/Form/DeleteButton";

const InvoiceIndex = ({classes, invoices}) => (
    <Layout>
        <Paper className={classes.paper}>
            <Typography
                component="h1"
                variant="h4"
                align="center"
            >
                {i18n.get('invoice.title.index')}
            </Typography>

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell scope="col">{i18n.get('invoice.bill_date')}</TableCell>
                        <TableCell
                            scope="col">{i18n.get('invoice.bill_value', {'unit': i18n.get('invoice.currencies.with_EUR')})}</TableCell>
                        <TableCell scope="col">{i18n.get('invoice.order_number')}</TableCell>
                        <TableCell scope="col">{i18n.get('house.assignment')}</TableCell>
                        <TableCell scope="col">{i18n.get('invoice.actions')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {invoices && invoices.length > 0 && invoices.map(invoice => (
                        <TableRow key={invoice.id}>
                            {/*<a href={`/`}*/}
                            <TableCell>
                                <FormattedDate value={invoice.bill_date}/>
                                {invoice.attachment_references && invoice.attachment_references.length > 0 && (
                                    <Tooltip title={i18n.get('invoice.tooltip.file_attached')}>
                                        <Icon>attach_file</Icon>
                                    </Tooltip>
                                )}
                            </TableCell>
                            <TableCell>
                                <FormattedNumber style="currency" value={invoice.bill_value} currency={"EUR"}/>
                            </TableCell>
                            <TableCell>
                                {invoice.order_number}
                            </TableCell>
                            <TableCell>
                                {invoice.house_attribute_costs
                                    && invoice.house_attribute_costs.length > 0
                                    && invoice.house_attribute_costs.map((house_attribute_cost) => (
                                        house_attribute_cost.house_attribute && house_attribute_cost.house_attribute.house && house_attribute_cost.house_attribute.house.name
                                    )).filter(function (el) {
                                        return el != null;
                                    }).join(', ')
                                }
                            </TableCell>
                            <TableCell>
                                <IconButton
                                    component="a"
                                    href={`/invoice/${invoice.id}`}
                                >
                                    <Icon>find_in_page</Icon>
                                </IconButton>

                                <DeleteButton
                                    confirmMessage={i18n.get('invoice.delete.confirm')}
                                    successMessage={i18n.get('invoice.delete.success')}
                                    errorMessage={i18n.get('invoice.delete.error')}
                                    href={`/invoice/${invoice.id}`}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Paper>
    </Layout>
);

const styles = theme => ({
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        paddingTop: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            paddingTop: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(InvoiceIndex);



// WEBPACK FOOTER //
// ./resources/assets/js/pages/invoice/Index.jsx